export default {

    changePassword({commit}, payload){
        let url = `/password`;
        return new Promise((resolve, reject)=>{
            window.axios.post(url, {
                old_password: payload.oldPassword,
                password: payload.password
            }).then(response=>{
                commit('SET_USER', response.data.user);
                
                let token = response.data.token;
                window.localStorage.setItem('tK', token);
                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                resolve();
            }).catch(error=>{
                reject(error);
            })
        });
    },

    completeTour({commit}){
        let url = `/tour/complete`;
        return new Promise((resolve, reject)=>{
            window.axios.post(url).then(response=>{
                commit('SET_USER', response.data.user);
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        });
    },

    saveInterests({commit}, payload){
        let url = `/interests`;
        return new Promise((resolve, reject)=>{
            window.axios.post(url, payload).then(response=>{
                commit('SET_USER', response.data.user);
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            })
        });
    },
}